<template>
  <div class="main-wrapper">
    <div ref="fotoPortadaRef" class="fotoportada-container">
      <div class="overlay">
        
        <!-- MIS Xasdaasdasdasdasdasdasdasduperior -->
        <div ref="misXvTopRef" class="mis-xv-wrapper-fixed">
          <img 
            src="@/assets/corona.png" 
            alt="Ornamento" 
            class="ornamento-img floating"
          >
          <div class="mis-xv-top glowing">MIS XV</div>
        </div>

        <!-- Contenido Central -->
        <div ref="nombreRef" class="centered-text-container"><br><br>
          <h1 class="nombre-principal">Alison</h1>
          
        
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null);
    const nombreRef = ref(null);
    const fechaRef = ref(null);
    const misXvTopRef = ref(null);

    onMounted(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });

      // 1. Revelado de la imagen de fondo (zoom out suave)
      tl.fromTo(fotoPortadaRef.value, 
        { scale: 1.2, opacity: 0 }, 
        { scale: 1, opacity: 1, duration: 2 }
      );

      // 2. Entrada de la corona y "MIS XV" desde arriba
      tl.from(misXvTopRef.value, {
        y: -50,
        opacity: 0,
        duration: 1.2
      }, "-=1.2");

      // 3. Aparición "mágica" del nombre (sube y se enfoca)
      tl.from(".nombre-principal", {
        y: 40,
        opacity: 0,
        letterSpacing: "10px",
        filter: "blur(10px)",
        duration: 2
      }, "-=0.8");

      // 4. Stagger de la fecha (uno por uno con rebote sutil)
      tl.to(".fecha-evento span", {
        opacity: 1,
        y: 0,
        stagger: 0.15,
        duration: 1,
        ease: "back.out(1.7)"
      }, "-=1");
    });

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvTopRef
    };
  }
};
</script>


<style scoped>
body {
  margin: 0;
  padding: 0;
}

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -65px;
  background-image: 
    linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.137)), 
    url('@/assets/1740D6BC-6E75-42E4-93EA-5DE634AF3BCA.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;

  /* Efecto de luz sutil */
  box-shadow: 0 -40px 80px rgba(255, 255, 255, 0.2) inset,
              0 20px 40px rgba(0, 0, 0, 0.3);
}


.overlay {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
}.nombre-principal{
  font-size: 50px !important;
}

/* MIS XV en esquina superior izquierda */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: -25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  height: auto;
  opacity: 1;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  letter-spacing: 1px;
  color: white;
  text-align: center;
}



.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 5px rgba(255,255,255,0.3);
  }
  to {
    text-shadow: 0 0 15px rgba(255,255,255,0.9);
  }
}

.centered-text-container {
  font-size: 80px !important;
  font-weight: 500;
  text-align: center;
  padding-top: 240px;
  padding-bottom: 20px;
  line-height: 1;
  padding-left: 40px;
  padding-right: 40px;

  font-family: 'british' !important;

  color: white; /* 🔥 FIX */
  text-shadow: 0 4px 20px rgba(0,0,0,0.6); /* 🔥 elegancia */

  white-space: nowrap;
  overflow: visible;
}
.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 18px;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  transform-origin: center;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}


.mis-xv-text {
  font-family: 'Daydream', cursive;
  font-size: 30px;
  color: #f8a4cf;
  text-align: right;
  width: 90%;
  margin-top: -10px;
  margin-bottom: -50px;
  letter-spacing: 2px;
  position: absolute;
  right: 5%;
  bottom: 60px;
  z-index: 3;
}

.separador-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  height: 80px;
  margin-top: -15px;
  margin-bottom: 30px;
}

.separador-img2 {
  width: 100%;
  height: auto;
  z-index: 2;
}
</style>
